"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRetrievable = exports.reupload = void 0;
const http_1 = require("../utils/http");
const stewardshipEndpoint = 'stewardship';
/**
 * Reupload locally pinned data
 * @param ky Ky instance
 * @param reference
 * @param options
 * @throws BeeResponseError if not locally pinned or invalid data
 */
async function reupload(requestOptions, reference) {
    await (0, http_1.http)(requestOptions, {
        method: 'put',
        url: `${stewardshipEndpoint}/${reference}`,
    });
}
exports.reupload = reupload;
async function isRetrievable(requestOptions, reference) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'get',
        responseType: 'json',
        url: `${stewardshipEndpoint}/${reference}`,
    });
    return response.data.isRetrievable;
}
exports.isRetrievable = isRetrievable;
